/* eslint-disable */

import ContentAPI from "@shared/_api/cms/content";
import {
    DELETE_CONTENT_SUCCESS,
    FETCH_CONTENT_LIST_SUCCESS, FETCH_PAGE_LIST_SUCCESS, FETCH_TEMPLATE_SUCCESS,
    INSERT_CONTENT_SUCCESS,
    SELECT_CONTENT_LIST_EDIT,
    UPDATE_CONTENT_SUCCESS
} from "./mutationTypes";
import TemplateApi from "@shared/_api/cms/template";

const state = {
    loading: false,
    contentList: [],
    pageList: [],
    templateList: [],
    editFields: null,
    editSchema: null
};

const getters = {
    contentPages: (state) => {
        let pages = [];

        for(let i = 0; i < state.pageList.length; i++) {
            pages.push({
                schema: state.pageList[i].template.templateFields,
                item: state.pageList[i]
            });
        }

        return pages;
    },
};

const actions = {
    fetchContentList({commit}) {
        return ContentAPI.fetchList().then(contentList => commit(FETCH_CONTENT_LIST_SUCCESS, contentList))
            .catch(error => {
                console.log(error)
            })
    },
    fetchPageList({commit}) {
        return ContentAPI.fetchPageList().then(pageList => commit(FETCH_PAGE_LIST_SUCCESS, pageList))
            .catch(error => {
                console.log(error)
            })
    },
    fetchTemplateList() {
        return TemplateApi.get().then((templateList) => commit(FETCH_TEMPLATE_SUCCESS, templateList))
            .catch(error => {
                console.log(error)
            })
    },
    setEditEntry({commit}, {editFields, editSchema}) {
        commit(SELECT_CONTENT_LIST_EDIT, {
            editFields,
            editSchema
        })
    },
    updateContent({commit}, {content}) {
        return ContentAPI.update(content).then(contentList => commit(UPDATE_CONTENT_SUCCESS))
            .catch(error => {
                console.log(error)
            })
    },
    insertContent({commit}, {content}) {
        return ContentAPI.insertListItem(content).then(contentList => commit(INSERT_CONTENT_SUCCESS))
            .catch(error => {
                console.log(error)
            })
    },
    deleteContent({commit}, {contentId}) {
        return ContentAPI.delete(contentId).then(() => commit(DELETE_CONTENT_SUCCESS))
            .catch(error => {
                console.log(error)
            })
    },
};

const mutations = {
    [FETCH_CONTENT_LIST_SUCCESS](state, contentList) {
        state.contentList = contentList;
    },
    [FETCH_PAGE_LIST_SUCCESS](state, pageList) {
        state.pageList = pageList;
    },
    [SELECT_CONTENT_LIST_EDIT](state, {editFields, editSchema}) {
        state.editFields = editFields;
        state.editSchema = editSchema;
    },
    [UPDATE_CONTENT_SUCCESS](state) {

    },
    [INSERT_CONTENT_SUCCESS](state) {

    },
    [DELETE_CONTENT_SUCCESS](state) {

    },
    [FETCH_TEMPLATE_SUCCESS](state, templateList){
        state.templateList = templateList;
    }

};

export const content = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};